/** @hidden */
export var MOBILE_SMALL_DEVISE = 500;
/** @hidden */
export var MOBILE_MEDIUM_DEVISE = 768;
